import * as React from 'react';
import { useForm, SubmitHandler } from "react-hook-form"
import { InputTextField } from '../FormFields/RenderInputTextField';
import { Contact } from '../../types/Contact';
import { useDispatch, useSelector } from "react-redux";
import { hideChildModal, hideModal } from "../../data/modal";
import { createContact, removeContact, updateContact } from '../../data/contacts';

import {
    Button,
    Divider,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";

import {
    Close as CloseIcon,
    Delete as DeleteIcon,
    Save as SaveIcon,
} from '@mui/icons-material';

const ContactForm = ({ contact, callback }) => {
    const dispatch = useDispatch();

    const selectedData = useSelector((state) => ({
        modal: state.modal,
    }));

    const { handleSubmit, control, formState } = useForm({
        defaultValues: contact ?? new Contact(),
    });
    const { isSubmitting } = formState;
    const [confirmOpen, setConfirmOpen] = React.useState(false);

    const onSubmit: SubmitHandler<Contact> = (data) => {
        if (contact) {
            dispatch(updateContact(data));
        } else {
            dispatch(createContact(data, callback));
        }
    }

    const handleCloseForm = () => {
        if (selectedData.modal.childModal) {
            dispatch(hideChildModal());
        } else {
            dispatch(hideModal());
        }
    };

    const handleDeleteConfirm = () => {
        dispatch(removeContact(contact));
        setConfirmOpen(false);
        handleCloseForm();
    };

    return (
        <>
            <form onSubmit={ handleSubmit(onSubmit) }>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <Typography variant='h6' className='form-fields-title'>
                            Contact Information
                        </Typography>
                        <Grid item xs={12} className='form-fields-container'>
                            <Grid item xs={12} sm={4}>
                                <InputTextField
                                    name='name'
                                    label='Name'
                                    control={ control }
                                    required
                                />
                            </Grid>
                            <Grid item  xs={12} sm={4}>
                                <InputTextField
                                    name='phoneNumber'
                                    label='Phone Number'
                                    control={ control }
                                />
                            </Grid> 
                            <Grid item  xs={12} sm={4}>
                                <InputTextField
                                    name='email'
                                    label='Email'
                                    control={ control }
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} marginTop={1} marginBottom={1}>
                        <Divider orientation="horizontal" />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant='h6' className='form-fields-title'>
                            Address
                        </Typography>
                        <Grid item xs={12} className='form-fields-container'>
                            <Grid item xs={12} sm={2}>
                                <InputTextField
                                    name='address.number'
                                    label='Number'
                                    control={ control }
                                />
                            </Grid> 
                            <Grid item xs={12} sm={4}>
                                <InputTextField
                                    name='address.street'
                                    label='Street'
                                    control={ control }
                                />
                            </Grid> 
                            <Grid item xs={12} sm={2}>
                                <InputTextField
                                    name='address.postalCode'
                                    label='Postal Code'
                                    control={ control }
                                />
                            </Grid> 
                            <Grid item xs={12} sm={2}>
                                <InputTextField
                                    name='address.city'
                                    label='City'
                                    control={ control }
                                />
                            </Grid> 
                            <Grid item xs={12} sm={2}>
                                <InputTextField
                                    name='address.country'
                                    label='Country'
                                    control={ control }
                                />
                            </Grid> 
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className='button-wrapper'>
                        <Grid container gap={2}>
                            <Button 
                                onClick={handleCloseForm}
                                disabled={ isSubmitting }
                                variant='contained'
                            >
                                <CloseIcon fontSize="inherit" />&nbsp;Close
                            </Button>
                            {contact && (
                                <Button 
                                    onClick={() => setConfirmOpen(true)}
                                    disabled={isSubmitting}
                                    variant="contained"
                                    color="error"
                                >
                                    <DeleteIcon fontSize="inherit" />&nbsp;Delete
                                </Button>
                            )}
                        </Grid>
                        <Button 
                            type='submit'
                            disabled={ isSubmitting }
                            variant='contained'
                        >
                            <SaveIcon fontSize="inherit" />&nbsp;Save
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title">Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                        Are you sure you want to delete this contact? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)} disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="error" disabled={isSubmitting} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ContactForm;